export default "__VITE_ASSET__CfUhaMSc__"